@switch (section.type) {
@case (sectionTypes.TRANSIT) {
<span class="h-4">
  <div class="flex items-center gap-1">
    @if (section.agency) {
    <!-- a11y: the agency logo is informative — alt = agency name so SR users
               hear which operator runs this transit leg. -->
    <img [src]="section.agency.name | agencyLogoByName" [attr.alt]="section.agency.name" class="h-6" />
    <span class="bg-gray px-1 py-0.5 rounded-lg text-xs">{{section.transport.name}}@if (section.transport.mode ===
      trasportModes.REGIONAL_TRAIN) {
      <span class="text-xs"> - {{section.transport.headsign}}</span>
      }</span>
    }
    @if(section.specialData.isAccessible) {
    <mot-button [icon]="section.specialData?.isCallNeeded ? 'wheelchair-move-phone' : 'wheelchair-move'" [type]="'icon'"
      ariaHaspopup="dialog" [ariaLabel]="section.specialData?.isCallNeeded ? accessibleWithOrderText : accessibleText"
      buttonClass="!w-6 !h-6 !min-w-0 !p-0 !rounded-full" iconClass="text-base font-black"
      (onClick)="openAccissibleModal(); $event.stopPropagation()" />
    }
    @if(section.specialData.isFlexible) {
    <mot-button [icon]="'phone'" [type]="'icon'" ariaHaspopup="dialog" [ariaLabel]="flexibleText"
      buttonClass="!w-6 !h-6 !min-w-0 !p-0 !rounded-full" iconClass="text-base font-black"
      (onClick)="openFlexibleModal(false); $event.stopPropagation()" />
    }

    @if(section.specialData.isOrderInAdvanced) {
    <mot-button [icon]="'phone'" [type]="'icon'" ariaHaspopup="dialog" [ariaLabel]="reserveInAdvancedText"
      buttonClass="!w-6 !h-6 !min-w-0 !p-0 !rounded-full" iconClass="text-base font-black"
      (onClick)="openFlexibleModal(true); $event.stopPropagation()" />
    }
  </div>
</span>
}
@case (sectionTypes.VEHICLE) {
<span class="flex gap-[0.125rem] items-center">
  <!-- a11y: car icon conveys travel mode; role=img + aria-label makes the mode readable by SR. -->
  <ng-icon name="car" class="font-black text-2xl pb-1" role="img" [attr.aria-label]="vehicleText"></ng-icon>
  <span class="text-xs">{{ timeText }}</span>
</span>
}
@case (sectionTypes.PEDESTRIAN) {
<span class="flex gap-[0.125rem] items-center">
  <!-- a11y: walking-person icon conveys travel mode; role=img + aria-label exposes "Walking" to SR. -->
  <ng-icon name="walking person" class="font-black text-2xl pb-1" role="img" [attr.aria-label]="walkingText"></ng-icon>
  <span class="text-xs">{{ timeText }}</span>
</span>
}
}